export default "__VITE_ASSET__DOUWgvaV__"